export default __webpack_public_path__ + "static/media/congrats.ab4f6a78.png";